export class SecretRefAws {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "arn",
            "baseName": "arn",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SecretRefAws.attributeTypeMap;
    }
    constructor() {
    }
}
